// Centralized query keys for React Query
export const variableKeys = {
  // Planner related queries
  planner: {
    all: ['planner'] as const,
    archiveVariable: (name: string) =>
      ['planner', 'archive-variable', name] as const,
    updateVariable: (name: string) =>
      ['planner', 'update-variable', name] as const,
    getVar: (name: string) => ['get-var', name] as const,
    variables: (name?: string, domains?: string[] | null) =>
      ['planner', 'variables', name, domains] as const,
    variable: (name: string) => ['planner', 'variable', name] as const,
    variableStats: (name: string) =>
      ['planner', 'variable-stats', name] as const,
    variableValue: (name: string) =>
      ['planner', 'get-variable-value', name] as const,
    rollout: (name: string) => ['planner', 'rollout', name] as const,
  },
} as const;
